import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation forgotPassword($email: String!) {
    forgotPasswordUser(email: $email)
  }
`

export interface ForgotPasswordInput {
  email: string
}

export interface ForgotPasswordOutput {
  forgotPasswordUser: boolean
}

export const useForgotPassword = () =>
  useMutation<ForgotPasswordOutput, ForgotPasswordInput>(mutation)
